import * as React from "react";
import {Col, Row} from 'reactstrap';
import {ll_url} from '../tools';

interface IBoxProps {
    title: string,
    image: string,
    onClick: any,
    selected?: boolean,
    className?: string,
    height?: string,
}

function statusImg(selected: boolean) {
    return <img src={ll_url(selected ? "/images/accept.png" : "/images/disable.png")} style={{
        height: "35px", width:"35px", position: "absolute", right: "1px"
    }}/>;
}

const MenuBox = (props: IBoxProps) => (
    <Col className={`col-pl-md-6 box_margin ${props.className}`} style={{height: props.height}}>
    <div className="col-pl-md-12" onClick={props.onClick} >
        {props.selected != null ? statusImg(props.selected) : null}
        <Row>
            <Col className="col-pl-md-6 grid_element" >
            <h2>{props.title}</h2>
            </Col>
            <Col className="col-pl-md-6 grid_element" >    
            <img className="gir_box_image" style={{height: props.height, width: "auto",}} src={ll_url(props.image)} />
            </Col>
        </Row>
    </div>
    </Col>
);

export default MenuBox;
